/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ContactoverviewQuery($uid: String!) {
    prismic {
      contactoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ContactoverviewBodyHerosearch {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              heading
              subheading
              text_alignment
              search_field_placeholder_text
            }
        },
        ... on PRISMIC_ContactoverviewBodyCardscontact {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
              modal_title
              modal_form_1
              modal_details_title_1
              modal_details_text_1
              modal_form_2
              modal_details_title_2
              modal_details_text_2
              modal_form_3
              modal_details_title_3
              modal_details_text_3
              modal_form_4
              modal_details_title_4
              modal_details_text_4
              modal_form_5
              modal_details_title_5
              modal_details_text_5
              modal_form_6
              modal_details_title_6
              modal_details_text_6
              modal_form_7
              modal_details_title_7
              modal_details_text_7
              modal_form_8
              modal_details_title_8
              modal_details_text_8
              modal_form_9
              modal_details_title_9
              modal_details_text_9
              modal_form_10
              modal_details_title_10
              modal_details_text_10
              modal_form_11
              modal_details_title_11
              modal_details_text_11
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_ContactoverviewBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_ContactoverviewBodyDocumentlist {
          type
            label
            primary {
              text_color
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
            }
            fields {
              section_heading
              link_1 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_1_text
              link_2 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_2_text
              link_3 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_3_text
              link_4 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_4_text
              link_5 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_5_text
              link_6 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_6_text
              link_7 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_7_text
              link_8 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_8_text
              link_9 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_9_text
              link_10 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_10_text
            }
        },
        ... on PRISMIC_ContactoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Contactoverview = ({ data, location }) =>
  data.prismic.contactoverview ? (
    <MainLayout location={location} layout='contactoverview'>
    <Helmet>
      <title>{(data.prismic.contactoverview.title[0] && data.prismic.contactoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.contactoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.contactoverview.path : 'https://www.digitalocean.com' + data.prismic.contactoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.contactoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.contactoverview.title[0] ? data.prismic.contactoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.contactoverview.description ? data.prismic.contactoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.contactoverview.open_graph_image ? data.prismic.contactoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.contactoverview.description ? data.prismic.contactoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.contactoverview.title[0] ? data.prismic.contactoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.contactoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.contactoverview.path : 'https://www.digitalocean.com' + data.prismic.contactoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.contactoverview.open_graph_image ? data.prismic.contactoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.contactoverview.body} />
    </MainLayout>
  ) : null;

Contactoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Contactoverview;
